import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorizationMapper } from '../mappers/authorization.mapper';
import { AuthApi } from '../api/auth.api';
import { AuthorizationEntity } from '../../domain/entities/authorization.entity';

/**
 * Authorization Repository.
 * Handles investigation and cases authorization data operations: HTTP API calls and DTO mapping.
 */
@Injectable({ providedIn: 'root' })
export class AuthorizationRepository {
  private readonly api = inject(AuthApi);
  private readonly mapper = inject(AuthorizationMapper);

  /**
   * Gets the current user's investigation authorization information.
   * @param context - The portal context ('cases' or 'investigations') to determine which authorization to fetch
   * @returns Observable with investigation role and permissions
   */
  getCurrentUserAuthorization(context: string): Observable<AuthorizationEntity> {
    return this.api.getCurrentUserAuthorization(context).pipe(
      map(dto => this.mapper.toDomain(dto))
    );
  }
}
